exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-header[data-v-7b7b4676] {\n\tjustify-content: center !important;\n}\n", ""]);

// exports
